// @flow
import React from 'react';
import { injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';
import Button from 'box-ui-elements/es/components/button/Button';
import compose from 'lodash/flowRight';
import LinkPrimaryButton from 'box-ui-elements/es/components/link/LinkPrimaryButton';
import messages from './messages';
import css from './completed-form-page.module.scss';
import SuccessFormIcon from '../../../icons/success-form';
import { withCurrentUser } from '../../../common/current-user';
import type { User } from '../../../types/User';
import isAnonymousUser from '../../../common/utils/isAnonymousUser';

type Props = InjectIntlProvidedProps & {
  currentUser: User,
  isAuthenticationRequired: boolean,
  numFiles: number,
};

const CompletedFormPage = (props: Props) => {
  const { intl, isAuthenticationRequired, numFiles, currentUser } = props;
  const { accountHost } = currentUser;

  const message = intl.formatMessage(
    numFiles === 1
      ? messages.completedFormMessageSingle
      : messages.completedFormMessage,
  );
  const isIFrame = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  const onGoToMyAccount = () => {
    window.location.href = `${accountHost}`;
  };
  return (
    <div className={css.container}>
      <div className={css.message}>{message}</div>
      <SuccessFormIcon />
      {isAuthenticationRequired && !isAnonymousUser(currentUser) && (
        <div className={css.goToMyAccount}>
          {isIFrame() ? (
            <LinkPrimaryButton
              data-testid="button-to-tab-to-box"
              href={accountHost}
              target="_blank"
            >
              {intl.formatMessage(messages.goToMyAccount)}
            </LinkPrimaryButton>
          ) : (
            <Button
              className="btn btn-primary"
              data-testid="button-to-box"
              onClick={onGoToMyAccount}
            >
              {intl.formatMessage(messages.goToMyAccount)}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export { CompletedFormPage };
export default compose(injectIntl, withCurrentUser)(CompletedFormPage);
